import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewPostPageStateModuleName } from '@/store/modules/modules'

export class ReviewPostPageStateViewModel {
  private store = useStore()

  isFirstOpendPage: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ReviewPostPageStateModuleName}/isFirstOpendPage`]
  )
  entrySummaryExpandedList: ComputedRef<{ [entryId: string]: boolean }> = computed(
    () => this.store.getters[`${ReviewPostPageStateModuleName}/entrySummaryExpandedList`]
  )

  entrySelectedReviewIndexList: ComputedRef<{ [entryId: string]: number }> = computed(
    () => this.store.getters[`${ReviewPostPageStateModuleName}/entrySelectedReviewIndexList`]
  )

  entryEditingList: ComputedRef<{ [entryId: string]: boolean }> = computed(
    () => this.store.getters[`${ReviewPostPageStateModuleName}/entryEditingList`]
  )

  setIsFirstOpendPage(flag: boolean): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setIsFirstOpendPage`, { flag })
  }

  setEntrySummaryExpandedList(list: { [entryId: string]: boolean }): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setEntrySummaryExpandedList`, { list })
  }

  setEntrySelectedReviewIndexList(list: { [entryId: string]: number }): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setEntrySelectedReviewIndexList`, { list })
  }

  setEntrySummaryExpandedFlag(entryId: string, flag: boolean): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setEntrySummaryExpandedFlag`, { entryId, flag })
  }

  setEntrySelectedReviewIndex(entryId: string, selectedReviewIndex: number): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setEntrySelectedReviewIndex`, {
      entryId,
      selectedReviewIndex
    })
  }

  setEntryEditingList(list: { [entryId: string]: boolean }): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setEntryEditingList`, { list })
  }

  setEntryEditingFlag(entryId: string, flag: boolean): void {
    this.store.commit(`${ReviewPostPageStateModuleName}/setEntryEditingFlag`, { entryId, flag })
  }
}
